import { useContext, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import styled from 'styled-components'

import { amountString, toast } from '../../utils'

import { StoresContext } from '../../provider/StoreProvider'

import { Wrap } from '../../components/container/Wrap'
import { Content } from '../../components/container/Content'
import { PagingContent } from '../../components/pagingList'
import { Header } from '../../components/header'
import { Text } from '../../components/text'

import { Color } from '../../theme/color'

export const SellHistoryDetail = observer(() => {
  const { homeStore } = useContext(StoresContext)
  const pagingStore = homeStore.sellHistoryPagingStore

  useEffect(() => {
    try {
      const loadData = async () => {
        await pagingStore.load(undefined, true)
      }
      loadData()
    } catch (error) {
      toast('페이지를 불러오는데 실패했습니다.', error, false)
    }
  }, [])

  return (
    <Wrap>
      <Header type="SUB" title="이전 매각 히스토리" />
      <Content>
        <PagingContent pagingStore={pagingStore}>
          <SellHistoryContainer>
            {pagingStore.list.map((d, i) => (
              <SellHistoryWrap key={i}>
                <img
                  src={d.imageUri}
                  alt={d.name}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null
                    currentTarget.src = '/img/thumbnail.svg'
                  }}
                />
                <ContentContainer>
                  <p className="title">{d.name ?? '-'}</p>
                  <p className="artist">{d.artist ?? '-'}</p>
                  <SellHistoryDataWrap>
                    <RevenueRateWrap>
                      {/* <IonIcon color="medium" icon={cashSharp} /> */}
                      <Text size={12} weight={400} color="primary_4">
                        {` ${amountString(String(d.revenueRate), false, 2)}%`}
                      </Text>
                    </RevenueRateWrap>
                    <RetentionDateWrap>
                      {/* <IonIcon color="medium" icon={timeSharp} /> */}
                      <Text size={12} weight={400} color="primary_4">
                        {` ${d.retentionDate}일`}
                      </Text>
                    </RetentionDateWrap>
                  </SellHistoryDataWrap>
                </ContentContainer>
              </SellHistoryWrap>
            ))}
          </SellHistoryContainer>
        </PagingContent>
      </Content>
    </Wrap>
  )
})

const SellHistoryContainer = styled.div`
  background-color: ${Color.gray_1};
  padding: 16px 20px;
`

const SellHistoryWrap = styled.div`
  padding: 16px;
  margin-bottom: 16px;
  display: grid;
  border-radius: 8px;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: 1fr;
  background-color: var(--ion-color-white);
  img {
    min-width: 80px;
    height: 80px;
    border-radius: 4px;
  }
`

const ContentContainer = styled.div`
  margin-left: 16px;
  grid-area: 1 / 2 / 2 / 9;
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
  .title {
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .artist {
    font-size: 12px;
    font-weight: 400;
    color: var(--ion-color-primary_light);
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .date {
    font-size: 12px;
    font-weight: 400;
    color: var(--ion-color-gray400);
  }
`

const SellHistoryDataWrap = styled.div`
  display: flex;
  margin-top: 15px;
`

const RevenueRateWrap = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`

const RetentionDateWrap = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`
